import LazadaMessage from "./message/lazada.js";
import ShopeeMessage from "./message/shopee.js";
import store from "@/store";
import vm from "../main.js";

class MessageHanle {

	static getInstance() {
	  if (!this.instance) {
	    this.instance = new MessageHanle();
	  }
	  return this.instance;
	}

	call(platform, message) {
		if (platform == 'lazada') {
			LazadaMessage[message.msgtype] && LazadaMessage[message.msgtype](message.data);
		} else if (platform == 'shopee') {
			ShopeeMessage[message.msgtype] && ShopeeMessage[message.msgtype](message.data);			
		}	
	}

	// 提示
	show_msg(message) {
		if (message.code == 0) {		
			vm.$Message.error(message.msg);
		}
	}

	// 上线
	online(message) {
		let data = {
			'id': message.data.admin_id,
			'attr': 'status',
			'value': message.data.status
		};
		store.commit("setUsersAttr", data);
	}

	// 下线
	offline(message) {
		let data = {
			'id': message.data.admin_id,
			'attr': 'status',
			'value': message.data.status
		};
		store.commit("setUsersAttr", data);
	}

	group_msg_send(message) {
		let tags = document.getElementsByTagName('group_msg');
		if (tags.length == 0) {
			vm.$Notice.open({
                title: '群发消息通知',
                desc: '待发送消息剩余'+message.data.wait_count+'条',
                duration: 0,
                render: h => {
                    return h('span', [
                        '待发送消息剩余 ',
                        h('group_msg', message.data.wait_count)

                    ])
                }
            });
		} else {
			tags[0].innerHTML = message.data.wait_count;
		}
		
	}

}

export default MessageHanle.getInstance();